export async function sendSlackNotification(
  service: string,
  error: string,
  heading: string,
) {
  try {
    await fetch(
      'https://hooks.slack.com/services/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',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          text: `<!everyone>\n*❌ ${heading}*\n.\n*Service: ${service}*\n ${error}.`,
        }),
      },
    );
  } catch (error) {
    console.error('Error sending message to Slack:', error);
  }
}
